import React from "react";

import { ReactComponent as CloseIcon } from "../../../../src/assets/close.svg";

const CloseButton = (props: any) => {
  return (
    <button
        type="button"
        className="close"
        onClick={() => props.onClick()}
        style={{
          position: "absolute",
          right: '-11px',
          padding: '1rem 1rem',
          margin: '-1rem -1rem -1rem auto',
          top: '-13px',
          opacity: 1
        }}>
        <CloseIcon />
      </button>
  );
}

export default CloseButton;
